export function getCookies(): Record<string, string> {
  return document.cookie.split('; ').reduce<Record<string, string>>((dict, cookieRow) => {
    const [key, value] = cookieRow.split('=')
    dict[key] = value
    return dict
  }, {})
}

export function extractCookie(encodedCookies: string, name: string): string | undefined {
  const cookies = encodedCookies.split('; ')
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue?.trim() || '')
    }
  }
  return undefined
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`
}

const LOCAL_DEVELOPMENT_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]', '::1'])

export function shouldSetSecureCookie(
  protocol: string = window.location.protocol,
  hostname: string = window.location.hostname,
): boolean {
  return protocol === 'https:' || !LOCAL_DEVELOPMENT_HOSTNAMES.has(hostname)
}

/**
 * Set a cookie on the document
 * @param name Name of the cookie
 * @param value Value to be saved
 * @param ttl Time to live *in seconds*
 * @param path Cookie path
 * @param samesite Same site string
 * @param domain Domain
 */
export function setCookie(name: string, value: string, ttl: number, path: string, samesite: string, domain?: string) {
  document.cookie = name + '=' +
    encodeURIComponent(value || '') +
    `; Expires=${new Date(+new Date() + ttl * 1000).toUTCString()}` +
    `; Path=${path}` +
    (domain ? '; Domain=' + domain : '') +
    `; SameSite=${samesite}` +
    (shouldSetSecureCookie() ? '; Secure' : '')
}
